import type { ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

export type StatsBoxWrapperProps = {
  title: ReactNode
  children?: ReactNode
  controls?: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
}

export const StatsBoxWrapper = ({
  title,
  children,
  controls,
  className,
  ref,
}: StatsBoxWrapperProps) => {
  return (
    <Paper
      ref={ref}
      elevation="1"
      className={cn(
        'flex flex-[1_0_auto] flex-col gap-4 rounded-md border border-divider px-6 py-4',
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <Typography variant="h6">{title}</Typography>
        {controls}
      </div>
      <div className="flex-[1_0_auto]">{children}</div>
    </Paper>
  )
}
